import { useState, useEffect } from "react";

const navItems = [
  { label: "홈", hash: "home" },
  { label: "변호사 소개", hash: "about" },
  { label: "언론보도", hash: "media" },
  { label: "수행사건", hash: "cases" },
  { label: "승소사례", hash: "cases-board" },
  { label: "상담안내", hash: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeHash, setActiveHash] = useState("home");

  useEffect(() => {
    const sectionIds = navItems.map((item) => item.hash);

    const handleScroll = () => {
      setScrolled(window.scrollY > 60);

      const scrollPos = window.scrollY + 120;
      let current = "home";

      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          if (top <= scrollPos) {
            current = id;
          }
        }
      }

      setActiveHash(current);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const showTransparent = !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        showTransparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md shadow-sm"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#home"
            onClick={() => setMobileOpen(false)}
            className="flex items-center gap-3 shrink-0"
          >
            <img
              src="/images/logob.webp"
              alt="법무법인 효민"
              className={`h-8 md:h-10 w-auto transition-opacity duration-300 ${
                showTransparent ? "opacity-0" : "opacity-100"
              }`}
              style={{ display: showTransparent ? "none" : "block" }}
            />
          </a>

          <div className="hidden md:flex items-center gap-8 lg:gap-10">
            {navItems.map((item) => {
              const isActive = activeHash === item.hash;
              return (
                <a
                  key={item.hash}
                  href={`#${item.hash}`}
                  className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 ${
                    isActive
                      ? showTransparent
                        ? "text-[oklch(0.84_0.13_100)]"
                        : "text-primary-500"
                      : showTransparent
                      ? "text-white"
                      : "text-foreground-700 hover:text-primary-500"
                  }`}
                >
                  {item.label}
                </a>
              );
            })}
          </div>

          <div className="hidden md:flex items-center">
            <a
              href="https://blog.naver.com/hmlaw3690"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                showTransparent
                  ? "bg-[oklch(0.78_0.17_100)] text-foreground-950 hover:bg-[oklch(0.70_0.16_100)]"
                  : "bg-primary-500 text-white hover:bg-primary-600"
              }`}
            >
              <i className="ri-external-link-line" />
              <span>블로그 바로가기</span>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              showTransparent ? "text-white" : "text-foreground-800"
            }`}
            aria-label="메뉴 열기"
          >
            {mobileOpen ? (
              <i className="ri-close-line text-xl" />
            ) : (
              <i className="ri-menu-line text-xl" />
            )}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive = activeHash === item.hash;
              return (
                <a
                  key={item.hash}
                  href={`#${item.hash}`}
                  onClick={() => setMobileOpen(false)}
                  className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </a>
              );
            })}
            <a
              href="https://blog.naver.com/hmlaw3690"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="mt-2 flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-primary-500 text-white text-base font-medium"
            >
              <i className="ri-external-link-line" />
              <span>네이버 블로그</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}